<div class="wrapper">
  <div class="container-fluid">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/dashboard">Dashboard</a></li>
              <li class="breadcrumb-item active">New terminal ordering</li>
            </ol>
          </div>
          <h4 class="page-title">Terminal(s) ordering page </h4>
        </div>
      </div>
    </div>
    <!-- end page title *ngIf="!id" -->
    <div class="row">
      <div class="col-12">
        <div class="card-box">

          <div class="row" *ngIf="raiseWarning">
            <div class="col-md-12 form-horizontal px-3">
              <ngb-alert [dismissible]="false">
                <strong>Warning!</strong> {{warning}}
              </ngb-alert>
            </div>
          </div>

          <div class="row" *ngIf="raiseDanger">
            <div class="col-md-12 form-horizontal px-3">
              <ngb-alert type="danger" [dismissible]="false">
                <strong>Error!</strong> {{danger}}
              </ngb-alert>
            </div>
          </div>

          <div [formGroup]="TerminalFormGroup">

            <div>
              <br />
              <b style="color: #477c93;"> Terminal details</b>
              <div class="fc-divider dropdown-divider" style="border: 1px solid #348cd4"></div>
              <br />
            </div>

            <div class="row form-horizontal">
              <div class="col-md-6 form-horizontal px-3">

                <div class="form-group row">
                  <label for="MerchantId" class="col-4 col-form-label">Merchant</label>
                  <div class="col-8">

                    <ng-select name="merchants" formControlName="merchantId" bindLabel="merchants" placeholder="List of merchants" [(ngModel)]="selectedMerchant" (change)="getTerminals($event)" [searchable]="true" #merchantSelect>
                      <ng-option [value]="merchant.merchantNumber" *ngFor="let merchant of merchants">
                        ({{merchant.merchantNumber}}) {{merchant.nameLocation}}
                      </ng-option>
                    </ng-select>
                    <ul *ngIf="submitted" class="parsley-errors-list filled">
                      <li *ngIf="TerminalFormGroup.controls['merchantId'].hasError('required')" class="parsley-required">Merchant Id is required.</li>
                      <li *ngIf="TerminalFormGroup.controls['merchantId'].hasError('minlength')" class="parsley-error">Merchant Id must be 15 characters.</li>
                    </ul>
                  </div>
                </div>


                <div class="form-group row">
                  <label for="terminalId" class="col-4 col-form-label">Terminal</label>
                  <div class="col-8">

                    <ng-select name="terminals" formControlName="terminalId" bindLabel="terminals" placeholder="List of terminals" [(ngModel)]="selectedTerminal" [searchable]="true" #terminalSelect>
                      <ng-option [value]="terminal.id" *ngFor="let terminal of terminals">
                        {{terminal.id}}
                      </ng-option>
                    </ng-select>

                    <ul *ngIf="submitted" class="parsley-errors-list filled">
                      <li *ngIf="TerminalFormGroup.controls['terminalId'].hasError('required')" class="parsley-required">Terminal Id is required.</li>
                      <li *ngIf="TerminalFormGroup.controls['terminalId'].hasError('minlength')" class="parsley-error">Terminal Id must be atleast 8 characters.</li>
                    </ul>
                  </div>
                </div>


                <div class="form-group row">
                  <label class="col-4 col-form-label">Make</label>
                  <div class="col-8">
                    <!--<ng-select2 id="deviceMake" formControlName="deviceMake" [data]="deviceMakeList" [options]="select2options" [placeholder]="'Please select a make...'" (valueChanged)="onMakeChange($event,TerminalFormGroup.controls[i], i)"></ng-select2>-->
                    <ng-select2 id="deviceMake" formControlName="deviceMake" [data]="deviceMakeList" [options]="select2options" [placeholder]="'Please select a make...'" (valueChanged)="onMakeChange($event)"></ng-select2>
                    <ul *ngIf="submitted" class="parsley-errors-list filled">
                      <li *ngIf="TerminalFormGroup.controls['deviceMake'].hasError('required')" class="parsley-required">Terminal make is required.</li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-4 col-form-label">Model</label>
                  <div class="col-8">
                    <!--<ng-select2 id="deviceModel" formControlName="deviceModel" [data]="terms.get('deviceModel').value" [options]="select2options" (valueChanged)="onDeviceModelChange(i, $event)"></ng-select2>-->
                    <ng-select2 formControlName="deviceModel" [data]="deviceModelList" [options]="select2options"></ng-select2>
                    <ul *ngIf="submitted" class="parsley-errors-list filled">
                      <li *ngIf="TerminalFormGroup.controls['deviceModel'].hasError('required')" class="parsley-required">Terminal model is required.</li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="terminaldelivery" class="col-4 col-form-label">Terminal(s) delivery method?</label>
                  <div class="col-8">
                    <ng-select2 id="terminaldeliveryFC" formControlName="terminaldeliveryFC" [data]="terminalDeliveryMethod" [options]="select2options"></ng-select2>
                    <ul *ngIf="submitted || this.TerminalFormGroup.controls['terminaldeliveryFC'].dirty" class="parsley-errors-list filled">
                      <li *ngIf="this.TerminalFormGroup.controls['terminaldeliveryFC'].value == ''" class="parsley-required">Please select terminal delivery method.</li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-4 col-form-label">Contact's name & surname</label>
                  <div class="col-8">
                    <input formControlName="contactNameSurnameFC" class="form-control" id="contactNameSurnameFC" placeholder="Contact name and surname" />
                    <ul *ngIf="submitted" class="parsley-errors-list filled">
                      <li *ngIf="TerminalFormGroup.controls['contactNameSurnameFC'].hasError('required')" class="parsley-required">Contact's name and surname is required.</li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-4 col-form-label">Contact's cell number</label>
                  <div class="col-8">
                    <input formControlName="contactNameCellNrFC" class="form-control" id="contactNameCellNrFC" placeholder="Contact cell number" />
                    <ul *ngIf="submitted" class="parsley-errors-list filled">
                      <li *ngIf="TerminalFormGroup.controls['contactNameCellNrFC'].hasError('required')" class="parsley-required">Contact's cell is required.</li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-4 col-form-label">Contact's email address</label>
                  <div class="col-8">
                    <textarea rows="3" formControlName="contactEmailAddressFC" class="form-control" id="contactEmailAddressFC" placeholder="Contact email address" ></textarea>
                    <ul *ngIf="submitted" class="parsley-errors-list filled">
                      <li *ngIf="TerminalFormGroup.controls['contactEmailAddressFC'].hasError('required')" class="parsley-required">Contact's email address is required.</li>
                    </ul>
                  </div>
                </div>


              </div>

              <div class="col-md-6 form-horizontal px-3">

                <div class="form-group row" style="display:none">
                  <div class="col-8">
                    <input formControlName="sameAsMerchantAddress" style="display:inline; width:10%;" type="checkbox" id="sameAsMerchantAddress" placeholder="Delivery address same as Merchant address" (ngModelChange)="updateDelivery($event)" />  <b>Delivery address same as Merchant address</b>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-4 col-form-label">Delivery address</label>
                  <div class="col-8">
                    <textarea rows="4" cols="24" formControlName="contactAddressFC" class="form-control" id="contactAddressFC" placeholder="Delivery address if not the same as Merchant's site address"></textarea>
                    <ul *ngIf="submitted" class="parsley-errors-list filled">
                      <li *ngIf="TerminalFormGroup.controls['contactAddressFC'].hasError('required')" class="parsley-required">Delivery address is required.</li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="regionCode" class="col-4 col-form-label">Region</label>
                  <div class="col-8">
                    <ng-select2 id="contactRegionFC" formControlName="contactRegionFC" [data]="regions" [options]="select2options"></ng-select2>
                    <ul *ngIf="submitted" class="parsley-errors-list filled">
                      <li *ngIf="TerminalFormGroup.controls['contactRegionFC'].hasError('required')" class="parsley-required">Region is required.</li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="city" class="col-4 col-form-label">City</label>
                  <div class="col-8">
                    <ng-select [items]="areaData"
                               [virtualScroll]="true"
                               [loading]="loading"
                               bindLabel="Area"
                               placeholder="Select City"
                               appendTo="body"
                               [(ngModel)]="selectedArea"
                               name="city"
                               (ngModelChange)="onCitySelected(selectedArea)"
                               (scroll)="onScroll($event)"
                               (scrollToEnd)="onScrollToEnd()"
                               formControlName="cityFC">
                      <ng-template ng-header-tmp>
                        <small class="form-text text-muted">Loaded {{areaBuffer.length}} of {{areaData.length}}</small>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-index="index">
                        <span>{{item.Area}} - {{item.Suburb}} (<span><b>{{item.StrCode}}</b></span><span *ngIf="item.StrCode == null"><b>{{item.BoxCode}}</b></span>)</span>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="postalServiceCode" class="col-4 col-form-label">Postal Service Code</label>
                  <div class="col-8">
                    <input formControlName="contactPostalServiceCodeFC" id="contactPostalServiceCodeFC" class="form-control" maxlength="4" placeholder="Postal code">
                    <ul *ngIf="submitted" class="parsley-errors-list filled">
                      <li *ngIf="TerminalFormGroup.controls['contactPostalServiceCodeFC'].hasError('required')" class="parsley-required">Postal code is required.</li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="country" class="col-4 col-form-label">Country</label>
                  <div class="col-8">
                    <ng-select2 id="countryFC" formControlName="countryFC" [data]="countries" [options]="select2options"></ng-select2>
                    <ul *ngIf="submitted" class="parsley-errors-list filled">
                      <li *ngIf="TerminalFormGroup.controls['countryFC'].hasError('required')" class="parsley-required">Country is required.</li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row" >
                  <label for="notes" class="col-4 col-form-label">Notes </label>
                  <div class="col-8">
                    <textarea rows="4" formControlName="notesFC" class="form-control" id="notesFC" placeholder="Notes" ></textarea>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-12">
                    <input formControlName="bulkOrder" style="display:inline; width:10%;" type="checkbox" id="bulkOrder" placeholder="Add device into a box - one waybill" /><b>Bulk order - When selecting bulk order, please note that all terminals will be shipped to the same address.</b>
                  </div>
                </div>

              </div>

            </div>

            <div class="form-group mb-0 justify-content-end row">
              <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="addTerminals()">
                + Add terminal
              </button>
            </div>

          </div>
          <div class="row" *ngIf="raiseDanger">
            <div class="col-md-12 form-horizontal px-3">
              <ngb-alert type="danger" [dismissible]="false">
                <strong>Error!</strong> {{danger}}
              </ngb-alert>
            </div>
          </div>
          <div class="row" *ngIf="deviceList.length > 0">
            <div class="col-12">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Merchant</th>
                    <th>Terminal</th>
                    <th>Make</th>
                    <th>Model</th>
                    <th>Delivey method</th>
                    <th>Bulk</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr scope="col" *ngFor="let s of deviceList">
                    <td>{{s.merchantNumber}}</td>
                    <td>{{s.terminalId}}</td>
                    <td>{{GetDeviceMake(s.deviceMake)}}</td>
                    <td>{{GetDeviceModel(s.deviceModel)}}</td>
                    <td>{{s.deliveryMethod}}</td>
                    <td>{{s.bulkOrder}}</td>
                    <td>
                      <button type="button"
                              class="btn btn-info waves-effect waves-light  fa-pull-right  mx-1"
                              (click)="viewContacts(s.terminalId)">
                        View contact information <i class="mdi mdi-information"></i>
                      </button>

                      <button type="button"
                              class="btn btn-danger waves-effect waves-light fa-pull-right mx-1"
                              (click)="delete(s.terminalId)">
                        Delete <i class="mdi mdi-delete"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row">

              <div class="col-4"></div>
              <div class="col-8">
                <div class="form-group mb-0 justify-content-end row">
                  <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="save()">
                    + save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
